import { Col, Row } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import LeftBar from "./LeftBar";
import Main from "./Main";
// WILL UNCOMMENT THESE WHEN SOCKET ISSUE IS RESOLVED
import { useLocation } from "react-router-dom";
import io from "socket.io-client";
import useVariables from "../../common/hooks/useVariables";
import { KEYS } from "../../Config/Keys";
const socket = io.connect(KEYS.API);
// const socket = null;

const ChatRoom = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const [active, setactive] = useState("");
  const [openChat, setopenChat] = useState(null);
  const [room, setRoom] = useState("");
  const [sponsorId, setSponsorId] = useState("");
  const [list, setList] = useState([]);
  const [online, setOnline] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 767);
  const { viewer } = useVariables();

  useEffect(() => {
    if (viewer?.flag === "sponsor") {
      setactive(id);
    }
  }, []);

  const resverseNavigate = () => {
    if (window.innerWidth > 767) {
      setIsDesktop(true);
    } else {
      setIsDesktop(false);
    }
  };

  const handleReRender = (data) => {
    setopenChat(data); // state change will re-render parent
  };
  useEffect(() => {
    window.addEventListener("beforeunload", () => window.history.replaceState({}, document.title));
    window.addEventListener("load", resverseNavigate);
    window.addEventListener("resize", resverseNavigate);
    resverseNavigate();

    return () => {
      setactive("");

      localStorage.removeItem("room");
      window.removeEventListener("beforeunload", window.history.replaceState({}, document.title));
      window.removeEventListener("load", resverseNavigate);
      window.removeEventListener("resize", resverseNavigate);
    };
  }, []);

  return (
    <Row className="ChatRoom" style={{ overflowY: isDesktop ? undefined : "hidden" }}>
      <Fragment>
        <Col xl={6} lg={7} md={9} xs={24} sm={24}>
          <LeftBar
            socket={socket}
            active={active}
            setactive={setactive}
            setopenChat={setopenChat}
            sponsorId={sponsorId}
            setSponsorId={setSponsorId}
            setRoom={setRoom}
            setList={setList}
            list={list}
          />
        </Col>

        {active ? (
          <Col xl={18} lg={17} md={15} xs={24} sm={24} className="messagePopup">
            <Main
              socket={socket}
              active={active}
              setactive={setactive}
              openChat={openChat}
              sponsorId={sponsorId}
              setSponsorId={setSponsorId}
              setopenChat={setopenChat}
              room={room}
              setOnline={setOnline}
              online={online}
              isDesktop={isDesktop}
              handleReRender={handleReRender}
            />
          </Col>
        ) : isDesktop ? (
          <Col
            xl={18}
            lg={17}
            md={15}
            xs={24}
            sm={24}
            className="messagePopup"
            style={{
              display: "grid",
              placeContent: "center",
              height: "100%",
              width: "100%",
              fontWeight: "bolder",
              background: "white",
              fontSize: "large"
            }}>
            Click on any chat to view Messages
          </Col>
        ) : null}
      </Fragment>
    </Row>
  );
};

export default ChatRoom;
